import { AxiosResponse } from "axios";
import { get, post, routes } from "api";
import { IEventRequestData, IWorkflowExecution } from "models/workflow.models";
import { WorkflowId } from "utils/constants/workflows.constants";

const workflows = {
  startWorkflow<T extends object>(
    workflowId: WorkflowId,
    data: T,
    isMockApiOn?: boolean,
  ) {
    return post<IWorkflowExecution<T>>(
      routes.workflows.workflows.start(workflowId),
      {
        data,
        isMockApiOn,
      },
    );
  },

  getWorkflowExecution(workflowId: string, isMockApiOn?: boolean) {
    return get<IWorkflowExecution>(
      routes.workflows.workflows.getWorkflowExecution(workflowId),
      {
        isMockApiOn,
      },
    );
  },

  createWorkflowEvent(
    workflowId: string,
    data: IEventRequestData,
    isMockApiOn?: boolean,
  ) {
    return post(routes.workflows.workflows.events(workflowId), {
      data,
      isMockApiOn,
    });
  },

  cancelWorkflowTasks(workflowExecutionId: string): Promise<AxiosResponse> {
    return post(
      routes.workflows.workflows.cancelWorkflowTasks(workflowExecutionId),
    );
  },
};

export default workflows;
